import gql from 'graphql-tag';

export const SaveContractorServiceZipMutation = gql`
  mutation ($contractServiceZip: ContractorServiceZipInput!) {
    saveContractorServiceZip (contractServiceZip: $contractServiceZip)
    {
      id,
      name,
      _Ebb_ContactId,
      zipCode
    }
  }
`;
export const BatchSaveContractorServiceZipMutation = gql`
  mutation ($contractServiceZips: [ContractorServiceZipInput!]!) {
    saveContractorServiceZips(contractServiceZips: $contractServiceZips) {
      id,
      name,
      _Ebb_ContactId,
      zipCode
      _Ebb_ZipCodeId
    }
  }
`;
export const DeleteContractorServiceZipMutation = gql`
  mutation ($contractServiceZip: ContractorServiceZipInput!) {
    deleteContractorServiceZip (contractServiceZip: $contractServiceZip)
    {
      id,
      name,
      _Ebb_ContactId,
      zipCode
    }
  }
`;
export const BatchDeleteContractorServiceZipMutation = gql`
  mutation ($contractServiceZips: [ContractorServiceZipInput!]!) {
    deleteContractorServiceZips(contractServiceZips: $contractServiceZips) {
      id,
      name,
      _Ebb_ContactId,
      zipCode
      _Ebb_ZipCodeId
    }
  }
`;
